import { render, staticRenderFns } from "./AppointmentsPaymentDialog.vue?vue&type=template&id=57cac060"
import script from "./AppointmentsPaymentDialog.vue?vue&type=script&lang=ts"
export * from "./AppointmentsPaymentDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports